import React, { useState, useCallback } from "react";
import { DropdownButton } from "@jsq/ds/core";
import {
  PayeeVendorWorkflow,
  PayeeEntityWorkflow,
  PayeeInvestmentWorkflow,
} from "@jsq/payments-components";
import { createPayeeDropdownContainer } from "./styles_vanilla.css";

type PayeeType = "Vendor" | "Entity" | "Investment";

const CreatePayeeDropdown: React.FC = () => {
  const [selectedType, setSelectedType] = useState<PayeeType | null>(null);

  const handleCreatePayee = useCallback((type: PayeeType) => {
    setSelectedType(type);
  }, []);

  const handleExit = useCallback(() => {
    setSelectedType(null);
  }, []);

  const renderWorkflow = useCallback(() => {
    switch (selectedType) {
      case "Vendor":
        return <PayeeVendorWorkflow onExit={handleExit} />;
      case "Entity":
        return <PayeeEntityWorkflow onExit={handleExit} />;
      case "Investment":
        return <PayeeInvestmentWorkflow onExit={handleExit} />;
      default:
        return null;
    }
  }, [selectedType, handleExit]);

  return (
    <>
      <DropdownButton
        label="Create new payee"
        align="right"
        variant="primary"
        dropdownClassName={createPayeeDropdownContainer}
      >
        <DropdownButton.Action onSelect={() => handleCreatePayee("Vendor")}>
          Vendor
        </DropdownButton.Action>
        <DropdownButton.Action onSelect={() => handleCreatePayee("Entity")}>
          Entity
        </DropdownButton.Action>
        <DropdownButton.Action onSelect={() => handleCreatePayee("Investment")}>
          Investment
        </DropdownButton.Action>
      </DropdownButton>
      {renderWorkflow()}
    </>
  );
};

export default CreatePayeeDropdown;
